export default "__VITE_ASSET__nG$0auNV__"